var React = require('react');

function MailWhite (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"mailwhite_Path_372","data-name":"mailwhite_Path 372","d":"M11.381,976.362a1.379,1.379,0,0,0-.511.1l7.81,6.824a.716.716,0,0,0,1.036,0l7.824-6.824a1.379,1.379,0,0,0-.511-.1Zm-1.366,1.186a1.428,1.428,0,0,0-.014.194v9.2a1.378,1.378,0,0,0,1.381,1.381H27.028a1.378,1.378,0,0,0,1.381-1.381v-9.2a1.43,1.43,0,0,0-.014-.194l-7.774,6.781a2.174,2.174,0,0,1-2.848,0Z","transform":"translate(-10 -976.362)","fill":"#fff"}));
}

MailWhite.defaultProps = {"width":"18.409","height":"11.966","viewBox":"0 0 18.409 11.966"};

module.exports = MailWhite;

MailWhite.default = MailWhite;
